export function createValuePreparer(payloadKey) {
  return function prepare(value) {
    return {
      payload: { [payloadKey]: value },
    };
  };
}

export function toggleArrayValue(items = [], value) {
  if (items.includes(value)) {
    return items.filter((item) => item !== value);
  }

  return [...items, value];
}
